(function () {
  var SwatchElement = customElements.get('pr-option');
  if (!SwatchElement || !SwatchElement.prototype.updateImage) return;

  var originalUpdateImage = SwatchElement.prototype.updateImage;
  if (originalUpdateImage.fbpSkipsUnchangedMedia) return;

  function updateImageOnlyWhenMediaChanges() {
    var media = this.swatch && this.swatch.featured_media;
    var productId = this.swatch && this.swatch.featured_image && this.swatch.featured_image.product_id;
    if (media && productId) {
      var activeMedia = document.querySelector(
        '#slider-big-' + productId + ' .swiper-slide-active[data-image-id]'
      );
      if (activeMedia && String(activeMedia.getAttribute('data-image-id')) === String(media.id)) return;
    }

    return originalUpdateImage.apply(this, arguments);
  }

  updateImageOnlyWhenMediaChanges.fbpSkipsUnchangedMedia = true;
  SwatchElement.prototype.updateImage = updateImageOnlyWhenMediaChanges;
})();
